import axios from "axios";
import { BASE_URL } from "../Utils/base_url";
const TypeCuisineRequest = async () => {
    return await axios.get(`${BASE_URL}/afficheTypeCuisine`);
}

const  Resto = async () => {
    return await axios.get(`${BASE_URL}/afficheResto`).then(response => response.data.donner)
    .catch(error => {
      console.error(error);
      return []; // En cas d'erreur, retourner un tableau vide ou une valeur par défaut
    });
}

const PopularRequest = async () => {
    return await axios.get(`${BASE_URL}/afficheRestoPopular`);
}


const ChercheRapideRequest = async () => {
    return await axios.get(`${BASE_URL}/afficheRechercheRapide`);
}

const PlusReserverRequest = async () => {
    return await axios.get(`${BASE_URL}/affichePlusReserver`);
}

const RechercheRequest = async (page, data) => {
    return await axios.post(`${BASE_URL}/recherche/${page}`, data);
}


const AfficheDataRequest = async () => {
    return await axios.get(`${BASE_URL}/afficheData`);
}

const AfficheHero = async () => {
    return await axios.get(`${BASE_URL}/afficheHero`);
}

const AfficheCritereHome = async () => {
    return await axios.get(`${BASE_URL}/afficheCritereHome`);
}


export { PopularRequest, TypeCuisineRequest,Resto, RechercheRequest, AfficheDataRequest, AfficheHero, AfficheCritereHome, ChercheRapideRequest,PlusReserverRequest };